var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// --------------------
var player01
$('.sec01_movie').click(function() {
  player01 = new YT.Player('player01', {
    videoId: 'MDlOmha1rx0',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange01
    }
  })
})
function onPlayerStateChange01(event) {
  var ytStatus = event.target.getPlayerState();
  if (ytStatus == YT.PlayerState.ENDED) {
    player01.destroy()
  }
}
// --------------------
var player02
$('.sec02_movie').click(function() {
  player02 = new YT.Player('player02', {
    videoId: 'XTxtkc0v3C4',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange02
    }
  })
})
function onPlayerStateChange02(event) {
  var ytStatus = event.target.getPlayerState();
  if (ytStatus == YT.PlayerState.ENDED) {
    player02.destroy()
  }
}
// --------------------
var player03
$('.sec03_movie').click(function() {
  player03 = new YT.Player('player03', {
    videoId: '89oSlDB1Vks',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange03
    }
  })
})
function onPlayerStateChange03(event) {
  var ytStatus = event.target.getPlayerState();
  if (ytStatus == YT.PlayerState.ENDED) {
    player03.destroy()
  }
}
// --------------------
var player04
$('.sec04_movie').click(function() {
  player04 = new YT.Player('player04', {
    videoId: 'xD03DlIPBok',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange04
    }
  })
})
function onPlayerStateChange04(event) {
  var ytStatus = event.target.getPlayerState();
  if (ytStatus == YT.PlayerState.ENDED) {
    player04.destroy()
  }
}
// --------------------
var player05
$('.sec05_movie').click(function() {
  player05 = new YT.Player('player05', {
    videoId: '4-dYcyLFM6g',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange05
    }
  })
})
function onPlayerStateChange05(event) {
  var ytStatus = event.target.getPlayerState();
  if (ytStatus == YT.PlayerState.ENDED) {
    player05.destroy()
  }
}
// --------------------

function onPlayerReady(event) {
  event.target.playVideo()
}
